import React from 'react';
import List from './List';

const CompletedList = ({ ...props }) => (
  <List
    url="installer-orders?order_status=complete"
    title="Completed Jobs"
    showCompletedAt={true}
    canManage={false}
    showOrderStatus={false}
    hideByDefault={true}
    canView={true}
    {...props}
  />
);

export default CompletedList;



// WEBPACK FOOTER //
// ./src/pages/InstallerOrders/CompletedList.js